<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <span class="account-already-exists-error" data-testid="account-already-exists-error" v-html="message" />
</template>
<script setup lang="ts">
    import {computed} from 'vue';
    import {useLocalePrefix, useTranslation} from '#imports';
    import {escapeHtml} from '@malt/sanitize';

    const props = defineProps<{email: string}>();

    const {t} = useTranslation();
    const {withLocalePrefix} = useLocalePrefix();

    const signInUrl = computed(() => `${withLocalePrefix('/signin')}?email=${encodeURIComponent(props.email)}`);
    const message = computed(() =>
        t('profile.features.account.form.email.error.account-already-exists-with-sign-in-link', [escapeHtml(signInUrl.value)]),
    );
</script>
